import { useEffect, useMemo, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./PolicyPage.css";
import { fetchTermsAndCondition , saveTermsAndCondtions } from "../services/privacyPolicyService";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../utils/Loader";
import logo from "../../images/urology-logo.png";
import { makePolicyEmailClickable } from "./policyContent";

export default function TermsAndConditionPage() {
  const loginData = useSelector((state) => state.login.data);

  const [policy, setPolicy] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const renderedPolicy = useMemo(
    () => makePolicyEmailClickable(policy),
    [policy]
  );

  useEffect(() => {
    fetchPolicy();
  }, []);

  const fetchPolicy = async () => {
    try {
      setLoading(true);
      const res = await fetchTermsAndCondition()
      setPolicy(res.data.policy.policy);
      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.error("Error fetching policy", error);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    try {

       const res = await saveTermsAndCondtions( {
        policy,
        updatedBy:loginData._id , // Replace with actual admin name or ID
      })
      toast.success("Terms & Condition Updated Successfully");
      setIsEditing(false);
    setLoading(false);

      fetchPolicy();
    } catch (error) {
      console.error("Error saving Terms & Condition", error);
      toast.error("Failed to save Terms & Condition");
    }
    setLoading(false);
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }], // Headings
      [{ font: [] }], // Font Family
    //   [{ size: ["small", false, "large", "huge"] }], // Font Size
      ["bold", "italic", "underline", "strike"], // Text Formatting
      [{ color: [] }, { background: [] }], // Text & Background Color
      [{ script: "sub" }, { script: "super" }], // Subscript/Superscript
      [{ align: [] }], // Justify Content (Align Left, Center, Right, Justify)
      [{ list: "ordered" }, { list: "bullet" }], // Ordered/Unordered Lists
      [{ indent: "-1" }, { indent: "+1" }], // Indentation
      ["blockquote", "code-block"], // Blockquote, Code Block
      ["link", "image", "video"], // Add Link, Image, Video
      ["clean"], // Remove Formatting
    ],
  };

  return (
    <div className="policy-page">
      {loading && <Loader />}

      <div className="policy-topbar">
        <Link className="policy-brand" to="/" aria-label="Back to home">
          <img src={logo} alt="Rainlink" />
        </Link>
        <Link className="policy-back" to="/">
          Back to home
        </Link>
      </div>

      <main className="policy-main">
        <div className="policy-card">
          {!isEditing && loginData.role == "ADMIN" && (
            <div className="policy-card-header">
              <Button
                className="policy-edit-btn"
                onClick={() => setIsEditing(true)}
              >
                Edit Terms
              </Button>
            </div>
          )}

          {isEditing ? (
            <div className="policy-editor">
              <ReactQuill
                theme="snow"
                value={policy}
                onChange={setPolicy}
                modules={modules}
                style={{ height: "450px" }}
              />

              <div className="policy-editor-actions">
                <Button
                  className="policy-save-btn"
                  onClick={handleSave}
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save"}
                </Button>
                <Button
                  className="policy-cancel-btn"
                  onClick={() => setIsEditing(false)}
                >
                  Cancel
                </Button>
              </div>
            </div>
          ) : (
            <div
              className="policy-content"
              dangerouslySetInnerHTML={{ __html: renderedPolicy }}
            />
          )}
        </div>
      </main>
    </div>
  );
}
